<template>
  <el-form class="rate-control" :model="control" label-width="70px">
    <el-form-item prop="name">
      <template slot="label">
        <span class="require-flag">*</span>
        名称
      </template>
      <el-input v-model="control.name"></el-input>
    </el-form-item>
    <el-form-item prop="optionStyle">
      <template slot="label">
        类型
      </template>
      <el-radio-group v-model="control.level">
        <el-radio :label="5">0-5</el-radio>
        <el-radio :label="10">0-10</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item prop="optionStyle">
      <template slot="label">
        图标
      </template>
      <el-select v-model="control.optionStyle" placeholder="请选择">
        <el-option
          v-for="item in rateTypes"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item prop="hint">
      <template slot="label">
        提示
      </template>
      <el-input v-model="control.hint"></el-input>
    </el-form-item>
    <el-form-item prop="description">
      <template slot="label">
        描述
      </template>
      <el-input v-model="control.description"></el-input>
    </el-form-item>
    <el-form-item prop="required">
      <template slot="label">
        必填
      </template>
      <el-checkbox v-model="control.required" :disabled="control.main"></el-checkbox>
    </el-form-item>
    <el-form-item prop="display">
      <template slot="label">
        显示
      </template>
      <el-checkbox v-model="control.display" :disabled="control.main"></el-checkbox>
    </el-form-item>
    <el-form-item prop="disabled">
      <template slot="label">
        不可编辑
      </template>
      <el-checkbox v-model="control.disabled"></el-checkbox>
    </el-form-item>
    <el-form-item prop="main">
      <template slot="label">
        标题
      </template>
      <el-checkbox v-model="control.main" @change="checkChange($event)"></el-checkbox>
    </el-form-item>
  </el-form>
</template>

<script>
import { rateTypes } from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/static"

export default {
  name: "rate-control",
  props: {
    control: Object
  },
  data() {
    return {
      rateTypes
    }
  },
  methods: {
    checkChange(value) {
      this.$emit("checkboxChange", "main", value)
    }
  }
}
</script>

<style lang="scss" scoped>
.rate-control {
  .el-select {
    width: 100%;
  }
}
</style>
